import { IconProps } from './types';

export function Refresh({ size, ...props }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8 2a6 6 0 0 1 5.196 3H12a.5.5 0 0 0 0 1h2.5a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-1 0v.804A7 7 0 1 0 15 8a.5.5 0 0 0-1 0A6 6 0 1 1 8 2Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
